import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['select', 'toggle'];

  connect() {
    // Check if any checkboxes are checked in each toggle, and set select value accordingly
    this.selectTargets.forEach((select, index) => {
      if (this.toggleTargets[index]) {
        const toggle = this.toggleTargets[index];
        const checkboxes = toggle.querySelectorAll('input[type="checkbox"]');
        const hasChecked = Array.from(checkboxes).some(cb => cb.checked);
        
        // If checkboxes are checked but select is set to "doesnt_have", update it
        if (hasChecked && select.value === 'doesnt_have') {
          select.value = 'has';
        }
      }
    });
    
    this.updateVisibility();
  }

  updateVisibility(event) {
    // If event is provided, update only the toggle associated with that select
    if (event) {
      const selectIndex = this.selectTargets.indexOf(event.target);
      if (selectIndex !== -1 && this.toggleTargets[selectIndex]) {
        const toggle = this.toggleTargets[selectIndex];
        const shouldShow = event.target.value === 'has';
        
        if (shouldShow) {
          this.toggleTargets[selectIndex].classList.remove('d-none');
        } else {
          this.toggleTargets[selectIndex].classList.add('d-none');
          // Clear all checkboxes when switching to "doesn't have"
          const checkboxes = toggle.querySelectorAll('input[type="checkbox"]');
          checkboxes.forEach(cb => {
            cb.checked = false;
          });
        }
      }
    } else {
      // On connect, update all toggles based on their corresponding selects
      this.selectTargets.forEach((select, index) => {
        if (this.toggleTargets[index]) {
          const shouldShow = select.value === 'has';
          if (shouldShow) {
            this.toggleTargets[index].classList.remove('d-none');
          } else {
            this.toggleTargets[index].classList.add('d-none');
          }
        }
      });
    }
  }
}

